import React, { useEffect, useState } from 'react'
import {
  Edit,
  TextInput,
  useTranslate,
  useNotify,
  TabbedForm,
  FormTab,
  useRedirect,
  useEditController,
  BooleanInput,
  required,
  NumberInput,
  FormDataConsumer,
  ImageInput,
  ImageField,
  TabbedFormTabs,
} from 'react-admin'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { Grid, Skeleton, CircularProgress, Box, LinearProgress } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { countryServices } from 'src/services/reservation/country/country.service'
import { businessTypeServices } from 'src/services/reservation/businessType/businessType.service'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'
import { FieldArray } from './logic/ArrayInput'
import { FieldArrayProduct } from './logic/ArrayInputProduct'
import { FormFiscalData } from './logic/FormFiscalData'
import { CardChildEntities } from 'src/components/uiElements/CRUD/CardChildEntities'
// import { getOptionsBusinessUnitFromWorkUnitSelected } from 'src/helper/userFieldsHelper'
import { CONSUMIDOR_FINAL_ID } from 'src/components/pages/administration/business-unit/logic/contrant'
import { JsonInput } from 'src/components/uiElements/react-hook-fields/JsonInputReact'
import { Credits } from 'src/components/pages/administration/business-unit/logic/Credits'
import { Notification } from 'src/components/pages/administration/work-unit/logic/Notification'
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput'
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput'
import { getAllChildrensId } from 'src/components/pages/sales/business-rule/logic/commonFunctions/getAllChildrensId'
import { FieldArrayBanner } from './logic/ArrayInputBanner'
import { bannerServices } from 'src/services/reservation/banner/Banner.service'
import { FieldArrayLanding } from './logic/ArrayInputLanding'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_GET } from 'src/helper/Permission'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { dueDateServices } from 'src/services/reservation/due-date/dueDate.service'
import { FieldArrayDueDateMethodBusinessUnit } from './logic/ArrayInputDueDateMethodBusinessUnit'
import { createDueDateMethodByBusinessUnit } from './logic/handleSendDueDateMethod'
import isEqual from 'lodash/isEqual'
import { useLocation } from 'react-router-dom'
import { FormBilling } from './logic/FormBilling'
import { ArrayInputPayments } from './logic/ArrayInputPayments'
import { PaymentTypesProvider } from './logic/PaymentTypesContext'

export const BusinessUnitEdit = (props, { id }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const location = useLocation()
  const [countryList, setCountryList] = useState([])
  const [loadingCountryList, setLoadingCountryList] = useState(false)
  const [businessTypeList, setBusinessTypeList] = useState([])
  const [loadingBusinessTypeList, setLoadingBusinessTypeList] = useState(false)
  const [businessUnitList, setBusinessUnitList] = useState([])
  const [loadingBusinessUnit, setLoadingBusinessUnit] = useState(false)
  const [workUnitList, setWorkUnitList] = useState([])
  const [loadingWorkUnitList, setLoadingWorkUnitList] = useState(false)
  const [userListManagerResposible, setUserListManagerResposible] = useState([])
  const [userListCommercialResposible, setUserListCommercialResposible] = useState([])
  const [loadingUserListManagerResposible, setLoadingUserListManagerResposible] = useState(false)
  const [loadingUserListCommercialResposible, setLoadingUserListCommercialResposible] = useState(false)
  const [productByBusinessUnitList, setProductByBusinessUnitList] = useState(null)
  const [loadingProductByBusinessUnitList, setLoadingProductByBusinessUnitList] = useState(true)
  const [workUnit, setWorkUnit] = useState(null)
  const [loadingDueDateMethodByBusinessUnit, setLoadingDueDateMethodByBusinessUnit] = useState(false)
  const [loadWorkUnit, setLoadWorkUnit] = useState(false)
  const [dueDateMethodByBusinessUnit, setDueDateMethodByBusinessUnit] = useState([])
  const [firstTime, setFirstTime] = useState({ businessUnit: true })
  const [tabIndex, setTabIndex] = useState('0');
  const { record, isLoading, isFetching } = useEditController({ resource: 'business-unit', id })

  useEffect(() => {
    getBusinessType()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (record) {
      if (record?.id) {
        getDueDateMethodRelation(record?.id)
      }

      if (record?.user?.id == record?.user_id) {
        setUserListManagerResposible([{ ...record?.user, id: record?.user_id }])
      }

      if (record?.salesperson_user_id_relation?.id == record?.salesperson_user_id) {
        setUserListCommercialResposible([
          { ...record?.salesperson_user_id_relation, id: record?.salesperson_user_id },
        ])
      }

      if (record?.country_id == record?.country?.id) {
        setCountryList([record?.country])
      }

      if (record?.work_unit_id == record?.work_unit?.id) {
        setWorkUnitList([record?.work_unit])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record])


  useEffect(() => {
    if (record) {
      if (!isLoading && !isFetching) {
        const products = [
          ...new Set([
            ...(record.product_by_work_unit_inheritance || []),
            ...(record.product_work_unit_by_business_unit_inheritance?.map(
              (elem) => elem.product_by_work_unit_relation
            ) || []),
          ]),
        ]
        setProductByBusinessUnitList(products)
        setLoadingProductByBusinessUnitList(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record, isLoading, isFetching])


  useEffect(() => {
    const pathSegments = location.pathname.split('/');
    const currentTab = pathSegments.length > 3 ? pathSegments[pathSegments.length - 1] : '0';
    setTabIndex(currentTab);
  }, [location.pathname]);

  const getDueDateMethodRelation = async (id) => {
    try {
      setLoadingDueDateMethodByBusinessUnit(true)
      const dueDateMethodByBusinessUnit = await dueDateServices.getDueDateMethodByBusinessUnit({
        business_unit_id: id,
      })
      setDueDateMethodByBusinessUnit(dueDateMethodByBusinessUnit)
    } catch (error) {
      setDueDateMethodByBusinessUnit([])
    } finally {
      setLoadingDueDateMethodByBusinessUnit(false)
    }
  }

  const getWorkUnit = async (long_name) => {
    try {
      if (!long_name) {
        return
      }
      setLoadingWorkUnitList(true)
      const allWorkUnit = await workUnitServices.getByAll({ long_name: long_name })
      setWorkUnitList(allWorkUnit)
      setLoadingWorkUnitList(false)
    } catch (error) {
      setWorkUnitList([])
      setLoadingWorkUnitList(false)
    }
  }

  const getWorkUnitByid = async (id) => {
    try {
      const work_unit = await workUnitServices.getById(id)
      if (work_unit) {
        setWorkUnit(work_unit)
        return work_unit
      }
    } catch (error) {
      setWorkUnit(null)
      console.log('getWorkUnitByid error', error)
    } finally {
      setLoadWorkUnit(false)
    }
  }

  const getBusinessUnit = async (long_name) => {
    try {
      if (!long_name) return
      setLoadingBusinessUnit(true)
      if (firstTime?.businessUnit) {
        setFirstTime((prevState) => ({ ...prevState, businessUnit: false }))
        setBusinessUnitList([formatParentRelation(record)])
        return [formatParentRelation(record)]
      }
      let work_unit = workUnit || null
      if (!work_unit) {
        if (record?.work_unit_id && !loadWorkUnit) {
          setLoadWorkUnit(true)
          work_unit = await getWorkUnitByid(record?.work_unit_id)
        }
      }

      if (work_unit) {
        const workUnitIds = getAllChildrensId(work_unit)
        const allBusinessUnit = await businessUnitServices.getByAll({
          long_name: long_name,
          fantasy_name: long_name,
          operator: 'or_ilike',
          limit: 15,
        })
        const allBusinessUnitFilter = allBusinessUnit.filter((businessUnit) =>
          workUnitIds.includes(businessUnit?.work_unit_id)
        )

        // Actualizar el estado solo si los datos han cambiado
        if (!isEqual(allBusinessUnitFilter, businessUnitList)) {
          setBusinessUnitList(allBusinessUnitFilter)
        }
        return
      }
      setBusinessUnitList([])
    } catch (error) {
      setBusinessUnitList([])
    } finally {
      setLoadingBusinessUnit(false)
    }
  }

  const getCountry = async (long_name) => {
    try {
      if (!long_name) {
        return
      }
      setLoadingCountryList(true)
      const allCountries = await countryServices.getByAll({ long_name: long_name })
      setCountryList(allCountries)
      setLoadingCountryList(false)
    } catch (error) {
      setCountryList([])
      setLoadingCountryList(false)
    }
  }

  let searchTimeoutManagerResposible
  let searchTimeoutCommercialResposible

  const getUserB2ManagerResposible = async (user, length = 2) => {
    clearTimeout(searchTimeoutManagerResposible)

    if (
      (!user?.firstname || user.firstname.length < length) &&
      (!user?.surname || user.surname.length < length)
    ) {
      if (record?.user) {
        setUserListManagerResposible([{ ...record?.user, user_id: record?.user_id }])
      }
      return
    }

    searchTimeoutManagerResposible = setTimeout(async () => {
      try {
        setLoadingUserListManagerResposible(true)
        let filter = {
          limit: 20,
        }
        if (user?.firstname) {
          filter.firstname = user?.firstname
        }
        if (user?.surname) {
          filter.surname = user?.surname
        }
        const allUser = await reservationServices.userReservtionFilter(filter)
        if (record?.user && allUser) {
          setUserListManagerResposible([...[{ ...record?.user, user_id: record?.user_id }], ...allUser])
        } else {
          setUserListManagerResposible(allUser)
        }
      } catch (error) {
        if (record?.user) {
          setUserListManagerResposible([{ ...record?.user, user_id: record?.user_id }])
        } else {
          setUserListManagerResposible([])
        }
      } finally {
        setLoadingUserListManagerResposible(false)
      }
    }, 1000)
  }

  const getUserB2CommercialResposible = async (user, length = 2) => {
    clearTimeout(searchTimeoutCommercialResposible)

    if (
      (!user?.firstname || user.firstname.length < length) &&
      (!user?.surname || user.surname.length < length)
    ) {
      if (record?.salesperson_user_id_relation) {
        setUserListCommercialResposible([
          { ...record?.salesperson_user_id_relation, salesperson_user_id: record?.salesperson_user_id },
        ])
      }
      return
    }

    searchTimeoutCommercialResposible = setTimeout(async () => {
      try {
        setLoadingUserListCommercialResposible(true)
        let filter = {
          limit: 20,
        }
        if (user?.firstname) {
          filter.firstname = user?.firstname
        }
        if (user?.surname) {
          filter.surname = user?.surname
        }
        const allUser = await reservationServices.userReservtionFilter(filter)
        if (record?.user && allUser) {
          setUserListCommercialResposible([
            ...[{ ...record?.salesperson_user_id_relation }],
            ...allUser,
          ])
        } else {
          setUserListCommercialResposible(allUser)
        }
        setUserListCommercialResposible(allUser)
      } catch (error) {
        if (record?.salesperson_user_id_relation) {
          setUserListCommercialResposible([{ ...record?.salesperson_user_id_relation }])
        } else {
          setUserListCommercialResposible([])
        }
      } finally {
        setLoadingUserListCommercialResposible(false)
      }
    }, 1000)
  }

  const getBusinessType = async () => {
    try {
      setLoadingBusinessTypeList(true)
      const allBusinessType = await businessTypeServices.getByAll()
      setBusinessTypeList(allBusinessType)
      setLoadingBusinessTypeList(false)
    } catch (error) {
      setBusinessTypeList([])
      setLoadingBusinessTypeList(false)
    }
  }

  const formatParentRelation = (record) => {
    try {
      if (record?.parent_relation) {
        const data = {
          long_name: record?.parent_relation?.long_name,
          parent_id: record?.parent_relation?.id,
          fiscal_data_relation: record?.parent_relation?.fiscal_data_relation,
          fantasy_name: record?.parent_relation?.fantasy_name,
          work_unit_id: record?.parent_relation?.work_unit_id,
          id: record?.parent_relation?.id,
        }
        return data
      }
      return null
    } catch (error) {
      return null
    }
  }

  const onChangeWorkUnit = (e) => {
    const workUnit = e.target?.data
    getWorkUnitByid(workUnit)
  }

  const onChangeBusinessUnit = (e) => {
    setLoadingProductByBusinessUnitList(true)
    const businessUnit = e.target.value

    const products = [
      ...new Set([
        ...workUnit.product_by_work_unit_inheritance || [],
        ...workUnit.product_by_work_unit_relation || [],
        ...businessUnit?.product_work_unit_by_business_unit_relation || [],
        ...businessUnit?.product_relation || [],
      ])
    ]
    setProductByBusinessUnitList(products)
    setLoadingProductByBusinessUnitList(false)
  }

  const createBannersByBusinessUnit = async (banners) => {
    const bannersToCreate = banners.filter(elem => elem?.banner_id && elem?.new_register)
    if (bannersToCreate.length > 0) {
      try {
        const promises = bannersToCreate.map(async (elem) => {
          delete elem.new_register
          delete elem.banner_relation
          elem.business_unit_id = record.id
          const response = await bannerServices.createBannerByBusinessUnit(elem)
          return response;
        });

        const results = await Promise.all(promises);
        return results;
      } catch (error) {
        notify(`ra.notification.create_error_banner_by_business_unit`, {
          type: 'error'
        })
        return false
      }
    }

    return true
  }

  const updateBannersByBusinessUnit = async (banners) => {
    const bannersToCreate = banners.filter(elem => elem.update_register)
    if (bannersToCreate.length > 0) {
      try {
        const promises = bannersToCreate.map(async (elem) => {
          delete elem.update_register
          delete elem.banner_relation
          delete elem._id
          const response = await bannerServices.updateBannerByBusinessUnit(elem)
          return response;
        });

        const results = await Promise.all(promises);
        return results;
      } catch (error) {
        notify(`ra.notification.update_error_banner_by_business_unit`, {
          type: 'error'
        })
        return false
      }
    }

    return true
  }

  const onSuccess = async (data) => {
    try {
      const promises = [
        await createBannersByBusinessUnit(data.banner_relation),
        await updateBannersByBusinessUnit(data.banner_relation),
        await createDueDateMethodByBusinessUnit(data.due_date_method_relation, data?.id),
      ]
      await Promise.all(promises);
    } catch (error) {
      // console.log("error", error);
    } finally {
      notify('ra.notification.updated_success_femenine', {
        type: 'success',
        messageArgs: { element: translate('ra.single_entity.business-unit') },
      })
      redirect('/business-unit')
    }
  }

  const onError = () => {
    notify('ra.notification.updated_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.business-unit') },
    })
  }

  const is_fiscal_data_relation_null = (fiscal_data) => {
    if (fiscal_data) {
      const props = Object.keys(fiscal_data)
      if (props.length !== 0) {
        let someFieldComplete = []
        props.forEach((prop) => {
          if (fiscal_data[prop] !== null && fiscal_data[prop] !== undefined) {
            someFieldComplete.push(fiscal_data[prop])
          }
        })
        if (someFieldComplete.length >= 1) {
          return false
        }
        return true
      }
    }
    return false
  }

  const formatData = (data) => {
    const newData = { ...data }
    if (data?.work_unit_id && typeof data?.work_unit_id != 'number') {
      newData.work_unit_id = newData?.work_unit_id?.id
    }
    if (data?.parent_id && typeof data?.parent_id != 'number') {
      newData.parent_id = newData?.parent_id?.id
    }
    if (data?.country_id && typeof data?.country_id != 'number') {
      newData.country_id = newData?.country_id?.id
    }
    if (data?.landing_relation?.length > 0) {
      newData?.landing_relation?.forEach(elem => {
        elem.landing_id = elem.landing_id || elem.landing_relation?.id
        delete elem.landing_relation
      })
    }
    if (data?.banner_relation?.length > 0) {
      newData?.banner_relation?.forEach(elem => {
        elem.banner_id = elem.banner_id || elem.banner_relation?.id
        delete elem.banner_relation
      })
    }

    if (data?.due_date_method_relation?.length > 0) {
      newData?.due_date_method_relation?.forEach((elem) => {
        elem.due_date_method_id = elem?.due_date_method_id?.id
      })
    }


    if (data?.user_id) {
      newData.user_id = data?.user_id?.id_reservation_user || data?.user_id?.id
    }

    if (data?.salesperson_user_id) {
      newData.salesperson_user_id =
        data?.salesperson_user_id?.id_reservation_user || data?.salesperson_user_id?.id
    }
    delete newData.user
    delete newData.salesperson_user_id_relation
    return newData
  }

  const transform = (formData) => {
    if( !formData.user_id || (typeof formData.user_id === 'number' && !isNaN(formData.user_id))){
      formData.user_id = formData.user
    }
    if( !formData.salesperson_user_id || (typeof formData.salesperson_user_id === 'number' && !isNaN(formData.salesperson_user_id))){
      formData.salesperson_user_id = formData.salesperson_user_id_relation
    }

    const mergedData = {
      ...record,
      ...formData,
    };

    mergedData.product_work_unit_by_business_unit_relation.forEach((elem) => {
      elem.product_by_work_unit_id = elem.product_by_work_unit_relation.id;
      delete elem.product_by_work_unit_relation;
    });

    if (
      mergedData?.fiscal_data_relation?.type_responsible_id !== CONSUMIDOR_FINAL_ID &&
      !mergedData?.short_name &&
      !mergedData?.long_name
    ) {

      const BusinessName = mergedData.fiscal_data_relation.name;
      mergedData.short_name = BusinessName;
      mergedData.long_name = BusinessName;
    }

    if (is_fiscal_data_relation_null(mergedData?.fiscal_data_relation)) {
      delete mergedData.fiscal_data_relation;
    }

    if (mergedData?.is_agency === false) {
      mergedData.agency_id = null;
    }

    sumCredits(mergedData);

    if (mergedData.excluded_products) {
      mergedData.excluded_product_id = mergedData.excluded_products.map(elem => elem.id);
      delete mergedData.excluded_products;
    }

    if (mergedData?.smtp_config == null) {
      mergedData.smtp_config = {
        transport: null,
        mailer_from: null,
        mailer_host: null,
        mailer_port: null,
        mailer_user: null,
        mailer_password: null,
        use_tls: false,
        use_ssl: false,
      };
    }

    delete mergedData.product_by_work_unit_inheritance;


    return formatData(mergedData);
  };

  const sumCredits = (data) => {
    if (data) {
      try {
        const credit_payload = {
          credit: data.credit + data.credit_to_sum,
          has_credit: data.has_credit,
          limit_credit: data.limit_credit,
          hash_business_unit: data.hash_business_unit,
        }
        businessUnitServices.updateCreditsByBusinessUnitHash(data.hash_business_unit, credit_payload)
      } catch (error) {
        console.log('updateCreditsByBusinessUnitHash error', error)
      }
    }
  }

  // const optionRendererResponsible = (choice) => `${choice.firstname} ${choice.surname}`
  const isLoadingTab = (translate_text) => {
    return (
      <Box display={'flex'} alignItems={'center'}>
        <CircularProgress sx={{ marginRight: '5px' }} size={'10px'} />
        {translate(translate_text)}
      </Box>
    )
  }

  const isComponentLoading =
    isLoading ||
    isFetching ||
    loadingBusinessTypeList ||
    loadingWorkUnitList ||
    loadingDueDateMethodByBusinessUnit ||
    loadingProductByBusinessUnitList

  return (
    <Edit
      {...props}
      transform={transform}
      mutationMode='pessimistic'
      mutationOptions={{ onSuccess, onError }}
      actions={null}
    >
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <CardCommon title={translate('ra.title.update_businessUnit')}>
            <TabbedForm
              lazy={false}
              toolbar={
                <CardCrudBottomButtons
                  btnSave={true}
                  btnDelete={true}
                  fieldsName={['short_name']}
                  genderElement='femenine'
                  loading={isComponentLoading}
                />
              }
              tabs={<TabbedFormTabs variant='scrollable' scrollButtons='auto' />}
              record={{ ...record, due_date_method_relation: dueDateMethodByBusinessUnit }}
            >
              <FormTab
                label={
                  isLoading || isFetching
                    ? isLoadingTab('ra.field.fiscal_data')
                    : translate('ra.field.fiscal_data')
                }
                disabled={isLoading || isFetching}
              >
                <FormFiscalData record={record} />
              </FormTab>

              <FormTab
                label={
                  isLoading || isFetching
                    ? isLoadingTab('ra.title.customer_file')
                    : translate('ra.title.customer_file')
                }
                disabled={isLoading || isFetching}
              >
                {tabIndex == 1 ? (
                  <Grid container spacing={3}>
                    <EditInputsWrap label={translate('ra.field.logo')}>
                      <ImageInput source='logo' label={''} className='image-input'>
                        <ImageField source='src' title='title' />
                      </ImageInput>
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.logo_voucher')}>
                      <ImageInput source='logo_voucher' label={''} className='image-input'>
                        <ImageField source='src' title='title' />
                      </ImageInput>
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.email')} required>
                      <TextInput source='email' label='' fullWidth validate={[required()]} />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.phone')}>
                      <NumberInput source='phone' label='' fullWidth />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.description')}>
                      <TextInput source='description' label='' fullWidth />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.country')} required>
                      <AutocompleteInput
                        source='country_id'
                        options={countryList}
                        loading={loadingCountryList}
                        optionsText={['long_name']}
                        optionValue='id'
                        onSearch={getCountry}
                        resetOnLoad={false}
                        useOptionValue={true}
                        validate={[required()]}
                        positionOptionsText={0}
                        useOptionValueByOptions
                        defaultValue={record?.country_id}
                      />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.state')}>
                      <TextInput source='state' label='' fullWidth />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.address')}>
                      <TextInput source='address' label='' fullWidth />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.contact')}>
                      <TextInput source='contact' label='' fullWidth />
                    </EditInputsWrap>

                    <EditInputsWrap
                      label={translate('ra.field.manager_responsible')}
                      required
                      tooltiptext={translate('ra.message.valid_characters', { num: 2 })}
                    >
                      <MultiAutocompleteInput
                        source='user_id'
                        options={userListManagerResposible}
                        loading={loadingUserListManagerResposible}
                        optionsText={['firstname', 'surname']}
                        optionValue='id'
                        onSearch={getUserB2ManagerResposible}
                        resetOnLoad={false}
                        fields={['firstname', 'surname']}
                        defaultValue={record?.user_id}
                        validate={[required()]}
                      />
                    </EditInputsWrap>

                    <EditInputsWrap
                      label={translate('ra.field.commercial_responsible')}
                      required
                      tooltiptext={translate('ra.message.valid_characters', { num: 2 })}
                    >
                      <MultiAutocompleteInput
                        source='salesperson_user_id'
                        options={userListCommercialResposible}
                        loading={loadingUserListCommercialResposible}
                        optionsText={['firstname', 'surname']}
                        optionValue='id'
                        onSearch={getUserB2CommercialResposible}
                        resetOnLoad={false}
                        fields={['firstname', 'surname']}
                        defaultValue={record?.salesperson_user_id}
                        validate={[required()]}
                      />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.business_type')} required>
                      {loadingBusinessTypeList ? (
                        <Skeleton variant='rectangular' width={'100%'} height={40} />
                      ) : (
                        <SelectInput
                          size='small'
                          optionsText={['long_name']}
                          fullWidth
                          label=''
                          showSearch
                          source='business_type_id'
                          options={businessTypeList}
                          validate={[required()]}
                          defaultValue={record?.business_type_id}
                        />
                      )}
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.work_unit')} required>
                      <AutocompleteInput
                        source='work_unit_id'
                        options={workUnitList}
                        loading={loadingWorkUnitList}
                        optionsText={['long_name']}
                        onChange={onChangeWorkUnit}
                        onSearch={getWorkUnit}
                        resetOnLoad={false}
                        optionValue='id'
                        useOptionValue={true}
                        validate={[required()]}
                        positionOptionsText={0}
                        useOptionValueByOptions
                        defaultValue={record?.work_unit_id}
                      />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.parent_businessunit')} xs={12} md={8} lg={8}>
                      <AutocompleteInput
                        source='parent_id'
                        options={businessUnitList}
                        optionValue='id'
                        loading={loadingBusinessUnit}
                        optionsText={['long_name', 'fiscal_data_relation.name', 'fantasy_name']}
                        onSearch={getBusinessUnit}
                        onChange={onChangeBusinessUnit}
                        positionOptionsText={0}
                        resetOnLoad={false}
                        showAllOptionText={true}
                        defaultValue={
                          record?.parent_relation
                            ? { ...record?.parent_relation, parent_id: record?.parent_relation?.id }
                            : null
                        }
                      />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.json')} xs={12} md={6} lg={6}>
                      <JsonInput source='config' width='auto' />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.url')}>
                      <TextInput source='url' label='' fullWidth />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.state')}>
                      <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
                    </EditInputsWrap>
                    <EditInputsWrap label={translate('ra.field.is_agency')}>
                      <BooleanInput label={translate('ra.field.is_agency')} source='is_agency' fullWidth />
                    </EditInputsWrap>
                    <FormDataConsumer>
                      {({ formData }) =>
                        formData?.is_agency && (
                          <EditInputsWrap label={translate('ra.field.file_number')}>
                            <NumberInput label='' source='agency_id' fullWidth />{' '}
                          </EditInputsWrap>
                        )
                      }
                    </FormDataConsumer>
                  </Grid>
                ) : (
                  <LinearProgress style={{ width: '100%' }} />
                )}
              </FormTab>

              <FormTab
                label={
                  isLoading || isFetching ? isLoadingTab('ra.field.currency') : translate('ra.field.currency')
                }
                disabled={isLoading || isFetching}
              >
                {tabIndex == 2 ? (
                  <Grid container spacing={3}>
                    <FieldArray editMode />
                  </Grid>
                ) : (
                  <LinearProgress style={{ width: '100%' }} />
                )}
              </FormTab>

              <FormTab
                label={
                  isLoading || isFetching ? isLoadingTab('ra.field.product') : translate('ra.field.product')
                }
                disabled={isLoading || isFetching}
              >
                {tabIndex == 3 ? (
                  <Grid container spacing={3}>
                    <FieldArrayProduct
                      businessUnit={record}
                      productByBusinessUnitList={productByBusinessUnitList}
                      loadingProductByBusinessUnitList={loadingProductByBusinessUnitList}
                    />
                  </Grid>
                ) : (
                  <LinearProgress style={{ width: '100%' }} />
                )}
              </FormTab>

              {hasPermissionFunction('banner', PERMISSION_GET) && (
                <FormTab
                  label={
                    isLoading || isFetching ? isLoadingTab('ra.field.banner') : translate('ra.field.banner')
                  }
                  disabled={isLoading || isFetching}
                >
                  {tabIndex == 4 ? (
                    <Grid container spacing={3}>
                      <FieldArrayBanner />
                    </Grid>
                  ) : (
                    <LinearProgress style={{ width: '100%' }} />
                  )}
                </FormTab>
              )}
              {hasPermissionFunction('due-date-method', PERMISSION_GET) && (
                <FormTab
                  label={
                    loadingDueDateMethodByBusinessUnit
                      ? isLoadingTab('ra.field.expirations')
                      : translate('ra.field.expirations')
                  }
                  disabled={loadingDueDateMethodByBusinessUnit}
                >
                  <Grid container spacing={3}>
                    {tabIndex == 5 ? (
                      <FieldArrayDueDateMethodBusinessUnit
                        editMode={true}
                        business_unit_id={id || record?.id}
                        record={record}
                      />
                    ) : (
                      <LinearProgress style={{ width: '100%' }} />
                    )}
                  </Grid>
                </FormTab>
              )}
              {hasPermissionFunction('landing', PERMISSION_GET) && (
                <FormTab
                  label={
                    isLoading || isFetching ? isLoadingTab('ra.field.landing') : translate('ra.field.landing')
                  }
                  disabled={isLoading || isFetching}
                >
                  {tabIndex == 6 ? (
                    <Grid container spacing={3}>
                      <FieldArrayLanding />
                    </Grid>
                  ) : (
                    <LinearProgress style={{ width: '100%' }} />
                  )}
                </FormTab>
              )}
              {hasPermissionFunction('product-payment-by-business-unit', 'revision') && (
                <FormTab
                  label={
                    isLoading || isFetching ? isLoadingTab('payments') : translate('ra.field.payments')
                  }
                  disabled={isLoading || isFetching}
                >
                  {tabIndex == 7 ? (
                    <Grid container spacing={3}>
                      <PaymentTypesProvider>
                        <ArrayInputPayments businessUnitId = {record?.id}/>
                      </PaymentTypesProvider>
                    </Grid>
                  ) : (
                    <LinearProgress style={{ width: '100%' }} />
                  )}
                </FormTab>
              )}
              <FormTab
                label={
                  isLoading || isFetching ? isLoadingTab('ra.title.credits') : translate('ra.title.credits')
                }
                disabled={isLoading || isFetching}
              >
                <Grid container spacing={3}>
                  {tabIndex == 8 ? (
                    <Credits
                      hash_business_unit={record?.hash_business_unit}
                      isLoading={isLoading}
                      isFetching={isFetching}
                    />
                  ) : (
                    <LinearProgress style={{ width: '100%' }} />
                  )}
                </Grid>
              </FormTab>

              <FormTab
                label={
                  isLoading || isFetching
                    ? isLoadingTab('ra.title.notification')
                    : translate('ra.title.notification')
                }
                disabled={isLoading || isFetching}
              >
                {tabIndex == 9 ? (
                  <Grid container spacing={3}>
                    <Notification editMode />
                  </Grid>) : (
                  <LinearProgress style={{ width: '100%' }} />
                )}
              </FormTab>

              {hasPermissionFunction('billing', 'config') && (
                <FormTab 
                  label={
                    isLoading || isFetching ? isLoadingTab('ra.field.billing') : translate('ra.field.billing')
                  } 
                  disabled={isLoading || isFetching}
                >
                  {tabIndex == 10 ? (
                    <FormBilling record={record} />
                  ) : (
                    <LinearProgress style={{ width: '100%' }} />
                  )}
                </FormTab>
              )}
            </TabbedForm>
          </CardCommon>
        </Grid>
        <Grid item xs={4}>
          {isLoading || isFetching ? (
            <Skeleton variant='rectangular' width={'100%'} height={400} />
          ) : (
            <CardChildEntities recordContext={record?.children} />
          )}
        </Grid>
      </Grid>
    </Edit>
  )
}
